import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from "../../../../services/mygreencountry/auth.service";
import {Router} from "@angular/router";
import {ModalController, PopoverController} from "@ionic/angular";
import {StudentRequestComponent} from "../../modals/student-request/student-request.component";
import {StudentService} from "../../../../services/mygreencountry/student.service";
import {async} from "rxjs";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {TelegramComponent} from "../../modals/chose-group/telegram/telegram.component";
import {GroupLinks, StudentSelfGroup} from "../../../../types/interfaces";
import {PracticingComponent} from "../../modals/chose-group/practicing/practicing.component";
import {TransferLessonsComponent} from "../../modals/transfer-lessons/transfer-lessons.component";
import {LANGUAGES} from "../../../constants";
import {TranslocoService} from "@jsverse/transloco";
import {LocaleService} from "../../../../services/mygreencountry/locale.service";

@Component({
    selector: 'app-student-menu',
    templateUrl: './student-menu.component.html',
    styleUrls: ['./student-menu.component.scss'],
})
export class StudentMenuComponent implements OnInit {

    groups: GroupLinks[];
    authType:string;
    public isParent: boolean = false;

    currentGroupsLinks$ = this.studentService.getCurrentGroupsLinks();

    constructor(
        private authService: AuthService,
        private router: Router,
        private popoverController: PopoverController,
        private modalCtrl: ModalController,
        private studentService: StudentService,
        public myGcService: MyGreenCountry,
    ) {
    }

    ngOnInit() {
        // let groups = this.currentGroups$.getValue();
        let groups =   this.currentGroupsLinks$.getValue();

        if (groups) {
            this.groups = groups;
        }

        this.isParent = this.authService.isParent();
    }


    logout() {
        this.DismissClick()
        this.authService.logout();
        this.router.navigate(['/login']);
    }

    async DismissClick() {
        await this.popoverController.dismiss();
    }


    async closeModalAndNavigate(route: string) {
        await this.DismissClick();

        await this.router.navigate([route]);

    }

    async openRequestModal(type: string) {

        const modal = await this.modalCtrl.create({
            component: StudentRequestComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                type: type,
            }
        });

        await modal.present();
    }

    async openModal(type: string) {

        await this.openChoseGroupModal(type)

        //
        // if (this.groups) {
        //
        //     // if (this.groups?.length === 1) {
        //     //
        //     //     if (type === 'practicing') {
        //     //         this.openUrl(this.groups[0].practicingUrl)
        //     //     }
        //     //
        //     //     if (type === 'studentsMeeting') {
        //     //         this.openUrl(this.groups[0].studentsMeetingUrl)
        //     //     }
        //     //
        //     // } else {
        //
        //     if (this.groups.length!=0){
        //         let allFullCourses = this.groups.every(group => group?.isFullCourse);
        //
        //         if (allFullCourses) {
        //             let course = this.groups.find(group => group?.typeCourse === 1) ?? this.groups[0];
        //
        //             if (type === 'practicing') {
        //                 await this.openChoseGroupModal(type)
        //
        //             }
        //         } else {
        //
        //             await this.openChoseGroupModal(type)
        //         }
        //     }else{
        //         await this.openChoseGroupModal(type)
        //     }
        //
        // }
        // else{
        //     await this.openChoseGroupModal(type)
        // }


    }


    async openChoseGroupModal(type: string) {

        const modal = await this.modalCtrl.create({
            component:  type === 'practicing' ? PracticingComponent : TelegramComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.groups,
                type: type,
            }
        });

        modal.onWillDismiss().then(({ data, role }) => {
            if (role === 'openTransferModal') {
                this. DismissClick().then(() => this.openTransferModal());
            }
        });

        await modal.present();

    }

    openUrl(url: string) {
        if (url) {
            this.myGcService.openUrl(url);
        }
    }

    goToParentDashboard(){

        this.studentService.goToParentDashboard();
    }

    async openTransferModal() {
        console.log(this.groups)

        const modal = await this.modalCtrl.create({
            component: TransferLessonsComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.groups,
            }
        });

        await modal.present();
    }

}
